export default "__VITE_ASSET__DwCvix11__"